export default __webpack_public_path__ + "static/media/message_1-3.8a9768c9.svg";